// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as RemoveCartLineChain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { xGoogleAnalyticsState } from "@stoneage/App/Store/Reducers";
import { getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";

export const TrackGaRemoveCartLine: typeof PopulateApiParameter = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.removeFromCartLineEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const cart = getCurrentCartState(props.getState()).value;
        const cartLine = cart?.cartLines?.find(c => c.id === props.apiParameter.cartLineId);

        if (!cartLine) {
            return;
        }

        const googleAnalyticsData = {
            event: "remove_from_cart",
            currency: state.context.session.currency?.currencyCode,
            value: cart?.orderGrandTotal,
            items: [
                {
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    index: cartLine.line,
                    item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
                    item_category: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["category"] || ""
                        : undefined,
                    item_list_id: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["categoryId"] || ""
                        : undefined,
                },
            ],
            impersonation: trackAsImpersonation(state),
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(RemoveCartLineChain, TrackGaRemoveCartLine);
